
import { CoverageDSM_Summary } from "./CoverageDSMReport";
import { CoverageRSM_Summary } from "./CoverageRSMReport";
import { CoverageSummary } from "./CoverageSummary";
import { SessionList } from "./SessionList";

export const CoverageReport = {
  "sections": [
    // SessionList,
    // CoverageSummary,
    CoverageRSM_Summary,
    CoverageDSM_Summary
  ]
}